<template>
  <div id="app" v-cloak>
    <el-row
      v-if="show"
      class="headerWrapper"
      style="background-color: #f5f7fa !important"
    >
      <heard></heard>
    </el-row>
    <el-row style="min-height: 800px">
      <router-view v-on:header="header" />
    </el-row>
    <el-row style="padding: 0; margin: 0">
      <footers></footers>
    </el-row>
  </div>
</template>

<script>
import heard from "@/components/head/index";
import footer from "@/components/footdibu/dibu";

export default {
  name: "App",

  components: {
    heard: heard,
    footers: footer,
  },
  data() {
    return {
      currPath: "/",
      show: true,
    };
  },
  watch: {
    $route(to, from) {
      // 监听路由 如果地址上有tips则是token没有系统自动返回首页清除登录 提示
      if (to.query.tips && to.query.tips === "10000") {
        this.$message({
          message: "请重新登录！",
          type: "warning",
        });
        this.$router.push({ query: {} }); // 删除页面参数
        // setTimeout(e=>{
        //   location.href = "/";
        // },1500);
      }
      // 判断是否是 '/AI'，如果是，则隐藏头部和底部
      if (to.path === "/AI") {
        this.show = false;
      } else {
        this.show = true;
      }
    },
  },
  mounted() {
    console.log(this.$route);
    this.currPath = this.$route.path;
    console.log(this.currPath, "head=======");
  },
  created() {
    let modie = this._isMobile();
    if (modie) {
      // 跳转到手机端 首页
      if (window.location.pathname === "/") {
        if (window.location.search) {
          location.href = "/mt/" + window.location.search;
        } else {
          location.href = "/mt/";
        }
      }
      // 跳转到手机端 帮助中心
      if (window.location.pathname === "/help") {
        if (window.location.search) {
          location.href = "/mt/help/" + window.location.search;
        } else {
          location.href = "/mt/help/";
        }
      }
    }
  },
  methods: {
    header(bool) {
      console.log(bool, "000000");
      this.show = bool;
    },
    //Vue判断设备是移动端还是pc端
    _isMobile() {
      let flag = navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      );
      return flag;
    },
  },
};
</script>

<style scoped>
@import "assets/font/fonts.css";
#app {
  font-family: "PingFang Medium", "Helvetica Neue", sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #ffffff;
  margin: 0;
  /* width: 98.6vw; */
  /* width: 100vw;
  box-sizing: border-box;*/

  overflow-x: hidden;
}
[v-cloak] {
  display: none;
}
body {
  margin: 0 !important;
  padding: 0;
  overflow-y: scroll;
  overflow-x: hidden;
  min-height: 101%;
}
.loadingClass {
  position: fixed;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
}
</style>

<style>
body {
  padding-right: 0 !important;
}
body.el-popup-parent--hidden {
  padding-right: 0px !important;
  overflow: hidden !important;
}
.el-textarea__inner {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
}
.el-form-item__content {
  width: 300px;
}
</style>

<style scoped>
/*所有页面头部nav样式*/
/deep/ .el-breadcrumb__inner.is-link {
  font-size: 13px;
  font-weight: 400;
  color: #999999;
}
/deep/ .el-breadcrumb__item:last-child .el-breadcrumb__inner {
  color: #666666;
}
/deep/ .el-loading-mask {
  position: fixed;
}

/deep/ .el-tabs__item {
  color: #000 !important;
}
/deep/ .el-tabs__item.is-active {
  color: #f9bd00 !important;
}

/deep/ .el-tabs__item:hover {
  color: #000;
}
/deep/ .el-tabs__item.is-active {
  /*color: #fff;*/
  /*background-color: #c81623;*/
}
/deep/ .el-tabs__active-bar {
  background-color: #f9bd00;
}
</style>



// WEBPACK FOOTER //
// src/App.vue